import { ConditionOperators } from 'src/common/types/graphql.generated';

export const addSeparatedCustomFieldsNeTupleKeys = <
	T extends {
		environmentCustomFieldsNeTupleKey?: unknown;
		unitIdCustomFieldsNeTupleKey?: unknown;
	}
>(
	variables: T,
	environmentNeTupleKey?: string[],
	unitIdNeTupleKey?: string[]
): T => {
	let result = { ...variables };

	if (environmentNeTupleKey && environmentNeTupleKey.length > 0) {
		result = {
			...result,
			environmentCustomFieldsNeTupleKey: {
				value: environmentNeTupleKey,
				operator: ConditionOperators.All
			}
		};
	}

	if (unitIdNeTupleKey && unitIdNeTupleKey.length > 0) {
		result = {
			...result,
			unitIdCustomFieldsNeTupleKey: {
				value: unitIdNeTupleKey,
				operator: ConditionOperators.All
			}
		};
	}

	return result;
};
